/**
 * Script to use doofinder
 * Selector is .component-doofinder
 * Dataset must be present:
 * - hash-id
 * - lang
 * Looks for the first compoennt with hash-id to get the value and only
 * one hashid allowed per page.
 */

function init ()
{
    /**
     * The input selector tied to this component
     */
    const inputSelector = '.component-doofinder-input';

    /**
     * Find the first element with hashId set
     */
    const inputEl = document.querySelector(inputSelector+'[data-hash-id]');
    if (inputEl === null) {
        return;
    }

    const hashid = inputEl.dataset.hashId;
    const lang = inputEl.dataset.lang;

    (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://eu1-config.doofinder.com/2.x/339a5dbe-92a9-45bc-9386-942fcfdb8ffc.js';
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'doofinder-jssdk'));


    window.dfAsyncInit = function(){

        doofinder.init({
            hashid: hashid,
            zone: "eu1",
            searchBox: {
                selector: inputSelector,
                overlay: 'fullscreen'
            },
            "lang": lang,
            plugins: {
                historyPlugin: {
                    maxItems: 5,
                    storage: 'local'
                }
            }
        });
    };
}

export default {
    init,
}
